import { LANG_STORAGE_KEY } from './storedLanguage';

export type SiteLanguage = 'en' | 'lg' | 'sw';

export const LANGUAGES: { code: SiteLanguage; name: string; flag: string }[] = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'lg', name: 'Luganda', flag: '🇺🇬' },
  { code: 'sw', name: 'Swahili', flag: '🇹🇿' },
];

/** Switch the site language and remember it per visitor (WS-4). Used by the header and the footer. */
export function setSiteLanguage(i18n: { changeLanguage: (code: string) => unknown }, code: SiteLanguage): void {
  try {
    window.localStorage.setItem(LANG_STORAGE_KEY, code);
  } catch {
    // Private browsing can reject storage. The in-memory language still changes.
  }
  void i18n.changeLanguage(code);
}
